import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getEnums = () => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_ENUMS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/setting/enums`,
        config
      );
      if (data.statusCode===200) {
        dispatch({ type: "GET_ENUMS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_ENUMS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({ type: "GET_ENUMS_FAILED", payload: error?.response?.data?.message });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
// associated with adminReducer